import { Spinner, Stack } from "@altimateai/lego";
import PreviewShell from "./PreviewShell";

const PreviewLoadingState = () => (
  <PreviewShell>
    <Stack flex="1" align="center" justify="center">
      <Spinner  />
    </Stack>
  </PreviewShell>
);

export default PreviewLoadingState;
